import { render, staticRenderFns } from "./planeZoneSides.vue?vue&type=template&id=6ba0e0c1&scoped=true&"
import script from "./planeZoneSides.vue?vue&type=script&lang=js&"
export * from "./planeZoneSides.vue?vue&type=script&lang=js&"
import style0 from "./planeZoneSides.vue?vue&type=style&index=0&id=6ba0e0c1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba0e0c1",
  null
  
)

export default component.exports